import { enqueueSnackbar } from 'notistack';

export const toast = {
  success: (msg, opts) => enqueueSnackbar(msg, { variant: 'success', key: opts?.toastId, autoHideDuration: 3000 }),
  error: (msg, opts) => enqueueSnackbar(msg, { variant: 'error', key: opts?.toastId }),
  info: (msg, opts) => enqueueSnackbar(msg, { variant: 'info', key: opts?.toastId, autoHideDuration: 4000 }),
};
